import { gql } from "@apollo/client";

export const QUEUE_PATIENT_FRAGMENT = gql`
  fragment QueuePatientFragment on PatientOfQueue {
    uuid
    fullname
    gender
    addedAt
    triageStatus {
      _id
      currentStatus
      expiresAt
      createdAt
      updatedAt
    }
  }
`;

export const CLINIC_QUERY = gql`
  query getClinic($id: String!) {
    clinic(id: $id) {
      uuid
      name
    }
  }
`;

export const CREATE_QUEUE = gql`
  ${QUEUE_PATIENT_FRAGMENT}

  mutation CreatePatientQueue($input: CreatePatientQueueInput!) {
    createPatientQueue(input: $input) {
      _id
      name
      # We must also query for the patients array, even though it will be empty,
      # as we are merging the result of this mutation with the cache
      patients {
        ...QueuePatientFragment
      }
    }
  }
`;

export const FACILITY_QUEUES = gql`
  ${QUEUE_PATIENT_FRAGMENT}

  query getFacilityQueues {
    facilityQueues {
      _id
      name
      patients {
        ...QueuePatientFragment
      }
    }
  }
`;

export const FACILITY_QUEUE = gql`
  ${QUEUE_PATIENT_FRAGMENT}

  query getPatientQueue($input: FacilityQueueInput!) {
    facilityQueue(input: $input) {
      _id
      name
      patients {
        ...QueuePatientFragment
      }
    }
  }
`;
export const DELETE_QUEUE = gql`
  mutation DeletePatientQueue($input: DeletePatientQueueInput!) {
    deletePatientQueue(input: $input) {
      _id
      deletionSuccess
      message
    }
  }
`;
